module.exports = __webpack_public_path__ + "assets/img/jqdl.e31fcb67.png";